export default __webpack_public_path__ + "static/media/start-aec_EN.1fb49be8.png";